<template>
  <div :id="id" style="display: none">
    <table class="table table-sm table-bordered">
      <tbody>
      <tr>
        <td>Организация: <strong>{{additional.org.name}}</strong></td>
        <td>Подразделение: <strong></strong></td>
      </tr>
      <tr>
        <td>Работник: <strong>{{additional.worker.last_name + ' ' + additional.worker.first_name + ' ' + additional.worker.middle_name}}</strong></td>
        <td>Должность: <strong>{{additional.worker.function}}</strong></td>
      </tr>
      </tbody>
    </table>

    <h5 class="text-center mt-5 mb-2">{{additional.interface.title}}</h5>

    <table class="table table-sm table-bordered">
      <tbody>
      <tr>
        <th colspan="2">{{additional.interface.period}}</th>
        <th rowspan="2">Дата принятия на работу</th>
        <th rowspan="2">Суммарный оклад</th>
        <th rowspan="2">Средний дневной заработок</th>
        <th colspan="3">Количество дней</th>
        <th rowspan="2">Начисленная сумма</th>
      </tr>
      <tr>
        <th>с</th>
        <th>по</th>
        <th>отработанных</th>
        <th>календарных</th>
        <th>{{additional.interface.period2}}</th>
      </tr>
      <tr>
        <td>{{ getDate(additional.params.date_from) }}</td>
        <td>{{ getDate(additional.params.date_to) }}</td>
        <td>{{ getDate(additional.params.date_employment) }}</td>
        <td>{{additional.params.sum}}</td>
        <td>{{additional.params.daily_sum}}</td>
        <td>{{additional.params.days.fact}}</td>
        <td>{{additional.params.days.calendar}}</td>
        <td>{{additional.params.days.work}}</td>
        <td><strong>{{additional.result}}</strong></td>
      </tr>
      </tbody>
    </table>

    <h6>По месяцам:</h6>
    <table v-if="additional.result > 0" class="table table-sm table-bordered">
      <tbody>
      <tr>
        <th>Дата</th>
        <th>Дней</th>
        <th v-if="additional.feature=='hospital'">Предел 15 МРП</th>
        <th>Сумма</th>
      </tr>
      <template v-for="(item, index) in additional.daysinmonth">
        <tr :key="index">
          <td>{{item.name}}</td>
          <td>{{item.days}}</td>
          <td v-if="additional.feature=='hospital'" class="text-center"><span v-if="item.max">ДА</span></td>
          <td>{{item.amount}}</td>
        </tr>
      </template>
      </tbody>
    </table>

    <table class="table table-sm table-bordered">
      <tbody>
      <tr>

        <th>Месяц</th>
        <th>Отр.дней</th>
        <th>Календ.дней</th>
        <th>Начисление</th>
        <th>Коэффициент</th>
      </tr>


      <template v-for="(item, index) in additional.months">
        <tr :key="index">
          <td>
            {{ item.name }}
          </td>
          <td>
            {{ item.days.fact }}
          </td>
          <td>
            {{ item.days.calendar }}
          </td>
          <td>
            {{ item.sum }}
          </td>
          <td>
            {{ item.ratio }}
          </td>
        </tr>
      </template>
      </tbody>
    </table>

    <Signature :org="additional.org"></Signature>

  </div>
</template>

<script>
import Signature from "@/components/print/parts/Signature";
    export default {
      components: {
        Signature
      },
      name: 'Additionalcharges',
      props: ['additional', 'id'],
      data: function () {
        return {

        }
      }
    }
</script>
